import { TokenManager } from '@okta/okta-auth-js'
import type { AccessToken } from '@okta/okta-auth-js'

/* eslint-disable no-shadow */
export enum TokenStateKind {
  Missing = 'missing',
  Usable = 'usable',
  Expired = 'expired',
}
/* eslint-enable no-shadow */

export interface TokenValidity {
  readonly status: TokenStateKind
  readonly token?: AccessToken
}

export function getAccessTokenValidity(tokenManager: TokenManager): TokenValidity {
  const accessToken = tokenManager.getTokensSync().accessToken

  if (!accessToken) {
    return { status: TokenStateKind.Missing }
  }

  if (tokenManager.hasExpired(accessToken)) {
    return { status: TokenStateKind.Expired, token: accessToken }
  }

  return { status: TokenStateKind.Usable, token: accessToken }
}
